<template>
	<v-container>
		<v-row>
			<v-col
				cols="12"
				md="6"
				class="pa-3"
			>
				<v-row>
					<v-col>
						<h3>
							<translate>
								Your insurance
							</translate>
						</h3>
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Insurance</translate>:
					</v-col>
					<v-col>
						<v-row
							no-gutters
							align="center"
						>
							<v-col cols="1">
								<v-img
									class="ma-0"
									height="24px"
									width="32px"
									location="start"
									src="/frontoffice/images/brand/icons/icon-228.png"
								/>
							</v-col>
							<v-col
								class="pl-1"
							>
								<strong>
									Tulip Assist {{ complete ? " Mobile Complete" : " Mobile Essential" }}
								</strong>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Your device</translate>:
					</v-col>
					<v-col>
						{{ deviceName }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Premium</translate>:
					</v-col>
					<v-col>
						€ {{ price }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>IMEI</translate>:
					</v-col>
					<v-col>
						{{ data.device.imei }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>EAN</translate>:
					</v-col>
					<v-col>
						{{ data.device.ean }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Purchase date</translate>:
					</v-col>
					<v-col>
						{{ data.device.purchaseDate }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Purchase price</translate>:
					</v-col>
					<v-col>
						€ {{ data.device.purchasePrice }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Purchased at</translate>:
					</v-col>
					<v-col>
						{{ data.device.purchasedAt }}
					</v-col>
				</v-row>
			</v-col>
			<v-col>
				<v-row>
					<v-col>
						<h3>
							<translate>
								Your details
							</translate>
						</h3>
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Name</translate>:
					</v-col>
					<v-col>
						{{ fullName }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Birth date</translate>:
					</v-col>
					<v-col>
						{{ data.information.birthDate }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Country</translate>:
					</v-col>
					<v-col>
						{{ data.information.address.country }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Address</translate>:
					</v-col>
					<v-col>
						{{ address }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Email address</translate>:
					</v-col>
					<v-col>
						{{ data.information.emailAddress }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>Telephone number</translate>:
					</v-col>
					<v-col>
						{{ data.information.phoneNumber }}
					</v-col>
				</v-row>
				<v-row
					align="center"
				>
					<v-col>
						<translate>IBAN</translate>:
					</v-col>
					<v-col>
						{{ data.device.iban }}
					</v-col>
				</v-row>
			</v-col>
		</v-row>
		<v-row>
			<v-checkbox
				v-model:model-value="authorization"
				color="primary"
				@update:model-value="$emit('update:modelValue', authorization)"
			>
				<template
					#label
				>
					<p style="margin-bottom: 0px">
						<translate>
							I declare that the details have been entered correctly and that my device is not older than 3 months
						</translate>
					</p>
				</template>
			</v-checkbox>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'CheckoutSummary',
	props: {
		modelValue: {
			type: Boolean,
			default: null
		},
		data: {
			type: Object,
			default: null
		},
		complete: {
			type: Boolean,
			required: true,
		},
		price: {
			type: Number,
			required: true,
		},
		deviceName: {
			type: String,
			required: true,
		},
	},

	emits: ['update:modelValue',],

	data () {
		return {
			authorization: this.modelValue,
		};
	},

	computed: {
		fullName () {
			const information = this.data.information;

			return `${information.firstName} ${information.infix ? `${information.infix} ` : '' } ${information.lastName}`;
		},

		address () {
			const address = this.data.information.address;

			if (address.housenumberSuffix) {
				return `${address.street} ${address.housenumber}${address.housenumberSuffix}, ${address.postalcode}`;
			}
			return `${address.street} ${address.housenumber}, ${address.postalcode}`;
		}
	}
};
</script>
